import styled from "styled-components";

// Styled component for the background
const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/889e1b27-b887-4082-a896-b7921854ef78/722b627e-72e3-4422-80a7-aab78de2256e.png");
  background-position: center;
  background-size: cover;
  filter: blur(2px); /* Apply blur effect to the background image */
  z-index: -1; /* Ensure it's behind the main content */
`;

export default BackgroundImage;
